<template>
  <section class="wh_container">
    <input type="hidden" :value="value" />
    <div class="wh_content_all" tabindex="1" @focus="focus" @blur="blur">
      <div class="wh_top_changge">
        <li class="wh_content_li">{{ dateTop }}</li>
        <li @click="PreMonth(myDate, false)">
          <div class="wh_jiantou1"></div>
        </li>
        <li @click="NextMonth(myDate, false)">
          <div class="wh_jiantou2"></div>
        </li>
      </div>
      <div class="wh_content">
        <div class="wh_content_item" v-for="(tag, key) in textTop" :key="key">
          <div class="wh_top_tag">{{ tag }}</div>
        </div>
      </div>
      <div class="wh_content">
        <div
          class="wh_content_item"
          v-for="(item, index) in list"
          :key="index"
          @click="clickDay(item, index)"
        >
          <div
            class="wh_item_date"
            v-bind:class="[
              { wh_isMark: item.isMark },
              { wh_other_dayhide: item.otherMonth !== 'nowMonth' },
              { wh_want_dayhide: item.dayHide },
              { wh_isToday: item.isToday },
              { wh_chose_day: item.chooseDay },
              setClass(item),
            ]"
          >
            {{ item.id }}
          </div>
        </div>
      </div>
      <div class="today-button">
        <span @click="selectToday()">
          Today
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import timeUtil from "./calendar";
export default {
  name: "Calendar",
  data() {
    return {
      myDate: [],
      list: [],
      historyChose: [],
      dateTop: "",
      firstEntry: false,
    };
  },
  props: {
    markDate: {
      type: Array,
      default: () => [],
    },
    markDateMore: {
      type: Array,
      default: () => [],
    },
    textTop: {
      type: Array,
      default: () => ["M", "T", "W", "T", "F", "S", "S"],
    },
    sundayStart: {
      type: Boolean,
      default: () => false,
    },
    agoDayHide: {
      type: String,
      default: `0`,
    },
    futureDayHide: {
      type: String,
      default: `2554387200`,
    },
    value: {},
  },
  created() {
    this.intStart();
    this.myDate = new Date();
    this.firstEntry = true;
  },
  methods: {
    selectToday() {
      let date = `${new Date().getFullYear()}/${new Date().getMonth() +
        1}/${new Date().getDate()}`;

      this.myDate = new Date();
      this.getList(this.myDate, date);
    },
    intStart() {
      timeUtil.sundayStart = this.sundayStart;
    },
    setClass(data) {
      let obj = {};
      obj[data.markClassName] = data.markClassName;
      return obj;
    },
    clickDay: function(item, index) {
      if (item.otherMonth === "nowMonth" && !item.dayHide) {
        this.getList(this.myDate, item.date);
      }
      if (item.otherMonth !== "nowMonth") {
        item.otherMonth === "preMonth"
          ? this.PreMonth(item.date)
          : this.NextMonth(item.date);
      }
    },
    ChoseMonth: function(date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = new Date(date);
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    PreMonth: function(date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "preMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    NextMonth: function(date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "nextMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    forMatArgs: function() {
      let markDate = this.markDate;
      let markDateMore = this.markDateMore;
      markDate = markDate.map((k) => {
        return timeUtil.dateFormat(k);
      });
      markDateMore = markDateMore.map((k) => {
        k.date = timeUtil.dateFormat(k.date);
        return k;
      });
      return [markDate, markDateMore];
    },
    getMonthName(number) {
      if (number === 1) {
        return "January";
      } else if (number === 2) {
        return "February";
      } else if (number === 3) {
        return "March";
      } else if (number === 4) {
        return "April";
      } else if (number === 5) {
        return "May";
      } else if (number === 6) {
        return "June";
      } else if (number === 7) {
        return "July";
      } else if (number === 8) {
        return "August";
      } else if (number === 9) {
        return "September";
      } else if (number === 10) {
        return "October";
      } else if (number === 11) {
        return "November";
      } else if (number === 12) {
        return "December";
      }
    },
    getList: function(date, chooseDay, isChosedDay = true) {
      const [markDate, markDateMore] = this.forMatArgs();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      this.dateTop = this.getMonthName(month) + " " + year;
      let arr = timeUtil.getMonthList(this.myDate);
      for (let i = 0; i < arr.length; i++) {
        let markClassName = "";
        let k = arr[i];
        k.chooseDay = false;
        const nowTime = k.date;
        const t = new Date(nowTime).getTime() / 1000;
        for (const c of markDateMore) {
          if (c.date === nowTime) {
            markClassName = c.className || "";
          }
        }
        k.markClassName = markClassName;
        k.isMark = markDate.indexOf(nowTime) > -1;
        k.dayHide = t < this.agoDayHide || t > this.futureDayHide;
        if (k.isToday) {
          this.$emit("isToday", nowTime);
        }
        let flag = !k.dayHide && k.otherMonth === "nowMonth";
        if (chooseDay && chooseDay === nowTime && flag) {
          this.$emit("choseDay", nowTime);
          this.historyChose.push(nowTime);
          k.chooseDay = true;
        } else if (
          this.historyChose[this.historyChose.length - 1] === nowTime &&
          !chooseDay &&
          flag
        ) {
          k.chooseDay = true;
        }
      }
      this.list = arr;
      if (this.firstEntry) {
        this.firstEntry = false;
        return;
      }
      this.$emit("input", this.historyChose[this.historyChose.length - 1]);
    },
    focus() {
      this.$emit("focus");
    },
    blur() {
      this.$emit("blur");
    },
  },
  mounted() {
    this.getList(this.myDate);
  },
  watch: {
    markDate: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    markDateMore: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    agoDayHide: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    futureDayHide: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    sundayStart: {
      handler(val, oldVal) {
        this.intStart();
        this.getList(this.myDate);
      },
      deep: true,
    },
    value(newValue) {
      // this.$emit("input", newValue);
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 460px) {
  .wh_item_date:hover {
    background: #ddd;
    cursor: pointer;
    border-radius: 100px;
  }
}
* {
  margin: 0;
  padding: 0;
}
section {
  display: inline-block;
  position: absolute;
  z-index: 100;
}
.wh_container {  
  margin: auto;
  max-width: 300px;
}
li {
  list-style-type: none;
}
.wh_top_changge {
  display: flex;
  border-bottom: 1px solid var(--white);
}
.wh_top_changge li {
  cursor: pointer;
  display: flex;
  color: #000;
  font-size: 18px;
  flex: 0.2;
  justify-content: center;
  align-items: center;
  height: 70px;
}
.wh_top_changge .wh_content_li {
  cursor: auto;
  flex: 1.6;
    font-family: "Roboto !important";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  justify-content: left;
  padding-left: 24px;
}
.wh_content_all {
    font-family: "Roboto !important";
  border-radius: 10px;
  box-shadow: 0 5px 50px 0 var(--very-light-pink);
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
  padding-bottom: 8px;
  min-width: 300px;
}
.wh_content {
  display: flex;
  flex-wrap: wrap;
  padding: 0 3% 0 3%;
  width: 100%;
}
.wh_content:first-child .wh_content_item_tag,
.wh_content:first-child .wh_content_item {
  color: #ddd;
  font-size: 16px;
}
.wh_content_item,
wh_content_item_tag {
  /* font-size: 15px; */
  /* width: 13.4%; */
  text-align: center;
  color: #000;
  position: relative;
  /* zeplin properties */
  opacity: 0.65;
    font-family: "Roboto !important";
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #000000;
}
.wh_content_item {
  height: 40px;
}
.wh_top_tag {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wh_item_date {
  width: 40px;
  height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;

    font-family: "Roboto !important";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  color: #272727;
}

.wh_jiantou1 {
  width: 10px;
  height: 10px;
  border-top: 2px solid #000;
  border-left: 2px solid #000;
  transform: rotate(-45deg);
  margin-right: 10px;
}
.wh_jiantou1:active,
.wh_jiantou2:active {
  border-color: #ddd;
}
.wh_jiantou2 {
  width: 10px;
  height: 10px;
  border-top: 2px solid #000;
  border-right: 2px solid #000;
  transform: rotate(45deg);
  margin-right: 20px;
}
.wh_content_item > .wh_isMark {
  margin: auto;
  border-radius: 100px;
  background: var(--primary);
  color: #fff;
  z-index: 2;
}
.wh_content_item .wh_other_dayhide {
  color: #bfbfbf;
}
.wh_content_item .wh_want_dayhide {
  color: #bfbfbf;
}
.wh_content_item .wh_isToday {
  background: var(--brown-grey);
  color: #fff;
  border-radius: 100px;
}
.wh_content_item .wh_chose_day {
  background: var(--primary);
  color: #fff;
  border-radius: 100px;
}
.wh_content_all:focus {
  outline: none;
}

.today-button {
  border-top: 1px solid #e8e8e8;
    font-family: "Roboto !important";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #434343;
  display: flex;
  justify-content: center;
  padding: 10px 0px 0px 0px;
}

.today-button span {
  cursor: pointer;
}
</style>
